import React from 'react'

export interface ValidationErrorAlertProps {
  errors?: Record<string, string[]> | null
  title?: string
}

/**
 * ValidationErrorAlert component - Displays validation errors from backend responses
 * Used for displaying 400 ValidationProblem responses with error details
 */
const ValidationErrorAlert: React.FC<ValidationErrorAlertProps> = ({ errors, title = 'Validation Error' }) => {
  // Check if there are any errors to display
  const hasErrors = errors && Object.keys(errors).length > 0

  if (!hasErrors) {
    return null
  }

  return (
    <div className='bg-warning/10 border border-warning/30 rounded-lg p-4'>
      <div className='w-full'>
        <h3 className='font-semibold text-warning text-base mb-3'>{title}</h3>
        <div className='space-y-2'>
          {Object.entries(errors).map(([key, messages]) => (
            <div
              key={key}
              className='text-sm'
            >
              <p className='font-medium text-warning'>{key}</p>
              <ul className='list-disc list-inside ml-2 mt-1'>
                {messages.map((message, index) => (
                  <li
                    key={index}
                    className='text-xs text-warning'
                  >
                    {message}
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>
    </div>
  )
}

export default ValidationErrorAlert
